'use strict';

var template    = require('employer/templates/payroll/PayrollView.html');
var StepTwoView = require('./stepTwo/Main');

module.exports = Backbone.View.extend({
    contentView: null,

    initialize: function(options) {
        this.options = options;

        return this.render();
    },

    render: function() {
        this.$el.html(template({period: this.period}));

        return this;
    },

    renderContent: function(options) {
        if (this.contentView !== null) {
            this.contentView.remove();
            this.contentView = null;
        }

        options.viewMode = true;
        options.period   = this.period;
        options.el       = this.$('#content');
        this.contentView = new StepTwoView(options);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/PayrollView.js